import { type Options } from '@glidejs/glide';

function Home() {
  const $document = $(document);
  const width = $(window).width() || 0;

  const init = () => {
    HeroSlider();
    DepartamentSlider();
    FeaturedSlider();
  };

  const HeroSlider = () => {
    const $container = $document.find('.banner-slider-container.type-1');
    $document.find('.banner-slider-container.type-1 .glide__arrow--left').attr('data-glide-dir', "<");

    $container.find('.glide__arrows').css({ width: `${$('.banner-slider > a').width()}px` });
  }

 
  const DepartamentSlider = () => {
    const $container = document.querySelector('.banner-slider-container.banner-depart');
    if (width > 1204 || !$container) return;

    const config = {
      type: 'carousel',
      autoplay: 40000,
      perView: 3,
      perSwipe: '|',
      peek: {
        before: 0,
        after: 20,
      },
      breakpoints: {
        650: {
          perSwipe: '|',
          perView: 2,
        },
      },
    } as unknown as Options;

    $container.classList.add('glide');
    window.aguadecoco.helpers.slider($container, config, true);
  };

  const FeaturedSlider = () => {
    const $container = document.querySelector('.third-slider-banner .featured-banner-container-slider-imgs');
    if (width > 1024 || !$container) return;

    const config = {
      type: 'carousel',
      autoplay: 40000,
      perView: 2,
      perSwipe: '|',
      breakpoints: {
        600: {
          perSwipe: '|',
          perView: 2,
        },
        728: {
          perSwipe: '|',
          perView: 3,
        },
      },
      peek: {
        before: 0,
        after: 20,
      },
    } as unknown as Options;

    $container.classList.add('glide');
    window.aguadecoco.helpers.slider($container, config, true);
  };

  init();
}

Home();
